import request from '@/utils/ai-request'

/**
 * 开始新对话
 */
export function startConversation(data) {
  return request({
    url: '/conversations/start',
    method: 'post',
    data
  })
}

/**
 * 发送消息
 */
export function chatMessage(data) {
  return request({
    url: '/conversations/chat',
    method: 'post',
    data
  })
}

/**
 * 获取对话详情
 */
export function getConversation(id) {
  return request({
    url: `/conversations/${id}`,
    method: 'get'
  })
}

/**
 * 获取对话消息历史
 */
export function getMessages(id) {
  return request({
    url: `/conversations/${id}/messages`,
    method: 'get'
  })
}

/**
 * 获取某场景的所有对话记录
 */
export function getConversationsByScenario(scenarioId) {
  return request({
    url: `/conversations/scenario/${scenarioId}`,
    method: 'get'
  })
}

/**
 * 获取当前用户的测试对话记录
 */
export function getMyTestConversations() {
  return request({
    url: '/conversations/my-tests',
    method: 'get'
  })
}

/**
 * 手动提前结束对话
 */
export function endConversation(conversationId) {
  return request({
    url: `/conversations/${conversationId}/end`,
    method: 'post'
  })
}
